export const removeItem = (_, payload) => payload.companyList.splice(payload.index, 1)
